'use strict';

var filter = require('../iterable/filter');
var identity = require('../functional/identity');
var mapAllKeys = require('../iterable/mapAllKeys');
var isEmpty = require('../value/isEmpty');
var isEqual = require('../value/isEqual');
var isNaN = require('../value/isNaN');
var type = require('../value/type');

var stringify = function stringify(value) {
  return isNaN(value) ? value : JSON.stringify(value);
};

var compare = function compare(_, value1, value2) {
  return deepCompare(value1, value2);
};

var deepCompare = function deepCompare(value1, value2) {
  if (value1 instanceof Object && value2 instanceof Object) {
    if (type(value1) !== type(value2)) {
      return 'type mismatch';
    }
    var result = filter(mapAllKeys({}, value1, value2, compare), identity);
    if (!isEmpty(result)) {
      return result;
    }
  } else if (!isEqual(value1, value2)) {
    return stringify(value1) + ' != ' + stringify(value2);
  }
};

module.exports = deepCompare;


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/misc/deepCompare.js
// module id = 2187
// module chunks = 37